import React, { useState } from 'react';
// import Dialog from '../../dialog.component';
import { CpButton, CpLoader, CpModal } from 'canopy-styleguide!sofe';

import styles from './user-referral.styles.css';

const REFERRAL_ROCK_PROGRAM_IDENTIFIER = '3034c969-172b-4e9c-971f-79ef4a5555fc';

export const UserReferralDialogComponent = ({
                                              firstName, lastName, email, directoryId,
                                              onClose = () => {
                                              }, phoneNumber = '',
                                            }) => {
  const [loading, setLoading] = useState(true);
  if (!(firstName || lastName || email || directoryId)) {
    return null;
  }

  const queryParams = `programidentifier=${encodeURIComponent(REFERRAL_ROCK_PROGRAM_IDENTIFIER)}&firstname=${encodeURIComponent(firstName)}&lastname=${encodeURIComponent(lastName)}&email=${encodeURIComponent(email)}&externalid=${encodeURIComponent(directoryId)}&phone=${encodeURIComponent(phoneNumber)}`;
  const iFrameReferralLink = `https://referrals.getcanopy.com/access?${queryParams}&view=iframe`;
  const anchorReferral = `https://referrals.getcanopy.com/access?${queryParams}`;
  return (
    <CpModal show={true} onClose={() => onClose()} width={600}>
      <CpModal.Header title="Canopy Referral Program"/>
      <CpModal.Body>
        <div className={styles.modalBody}>
          {loading ? (<CpLoader size="md"/>) : (
            <>
              <h6 className={styles.referralDescriptionTitle}>How Does it Work?</h6>

              <p className={styles.referralDescription}>
                Earn $25 for every referral that completes a demo
              </p>

              <p className={styles.referralDescription}>
                Collect up to $300 for every referral who signs up
              </p>

              <p className={styles.referralDescription}>
                AND your referral can get $100 when they sign up
              </p>
            </>
          )}

          <div className={styles.iFrameContainer}>
            <iframe src={iFrameReferralLink} className={styles.referralRockFrame}
                    height={loading ? '0px' : '480px'}
                    width="100%"
                    scrolling="no"
                    onLoad={() => setLoading(false)}/>
            {!loading && (
              <p className={styles.registerLink}>
                <a href={anchorReferral} target="_blank"
                   rel="noopener noreferrer">See dashboard and check referral status</a>
              </p>
            )}
          </div>
        </div>
      </CpModal.Body>
      <CpModal.Footer>
        <CpButton btnType="primary" onClick={() => onClose()}>
          Close
        </CpButton>
      </CpModal.Footer>
    </CpModal>
  );

};